import {useMemo} from "react"

export const useDate = (date: string) => useMemo(() => new Date(date), [date])
